import styled from 'styled-components';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import { DeviceType, Orientation, Platform, WriteDirection } from 'sofa-reborn-react';

export const PIG = styled.div<{
	platform: Platform;
}>`
	${(props) => props.platform === 'kiosk' && 'height: 100%'};
	${(props) => props.platform === 'kiosk' && 'display: flex'};
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	background-color: ${SkapaTheme.color.neutral.white};
	z-index: 500;
	border-top: ${(props) =>
		props.platform === 'kiosk' ? 'none' : '1px solid' + SkapaTheme.color.border.default};
	border-bottom: ${(props) =>
		props.platform === 'kiosk' ? 'none' : '1px solid' + SkapaTheme.color.border.default};
	overflow: hidden;
`;

export const ProductIntroGalleryWrapper = styled.div<{
	platform: Platform;
}>`
	padding: ${(props) => (props.platform === 'kiosk' ? '1rem' : '0')};
	${(props) => props.platform === 'kiosk' && 'width: 100%'};
`;

export const StyledProductIntroGallery = styled.div`
	display: flex;
	align-items: center;
	height: 100%;
	margin: 0 auto;
`;

export const GalleryWrapper = styled.div`
	height: 100%;
	width: 100%;
`;

export const ProductViewWrapper = styled.div<{
	platform: Platform;
	deviceType: DeviceType;
}>`
	margin-top: ${(props) => (props.deviceType === 'mobile' ? '8px' : '16px')};
	border-top: 1px solid ${SkapaTheme.color.border.light};
	overflow-y: ${(props) => (props.platform === 'kiosk' ? 'scroll' : 'visible')};

	::-webkit-scrollbar {
		display: none;
	}
`;

export const HeadlineWrapper = styled.div<{
	deviceType: DeviceType;
	orientation: Orientation;
}>`
	display: flex;
	justify-content: ${(props) =>
		props.deviceType === 'mobile' && props.orientation === 'landscape'
			? 'flex-start'
			: 'space-between'};
	flex-direction: row;
	margin-top: ${(props) => (props.deviceType === 'mobile' ? 0 : '8px')};
	padding: ${(props) => (props.deviceType === 'mobile' ? '0 8px' : '0 16px')};
`;

export const BackButtonWrapper = styled.div<{
	deviceType: DeviceType;
	writeDirection: WriteDirection;
	orientation: Orientation;
}>`
	display: flex;
	justify-content: ${(props) =>
		props.deviceType === 'mobile' && props.orientation === 'landscape' ? 'flex-end' : 'flex-start'};
	align-items: ${(props) =>
		props.deviceType === 'mobile' && props.orientation === 'portrait' ? 'start' : 'center'};
	margin-top: ${(props) =>
		props.deviceType === 'mobile' && props.orientation === 'portrait' ? '8px' : 0};
	${(props) =>
		props.deviceType === 'mobile' && props.orientation === 'landscape' ? 'flex:1;' : null}
`;

export const CardContainer = styled.div`
	cursor: pointer;
	height: 100%;
	min-height: 350px;
`;
